import { h } from 'preact';
import { Text } from 'preact-i18n';
import { calcChange, formatNumber, formatLastTradeTime } from '../../lib/util';
import { getGoodPrevClose } from '../../lib/util-stock-price';
import style from './style';

export const INTL_NS = 'stock-open-analysis';

const StockOpenAnalysis = ({ quote, symbol }) => {
	let name = quote.Name || quote.Symbol || symbol;
	let goodPrevClose = getGoodPrevClose(quote);

	let change = calcChange(quote.Open, goodPrevClose);
	let changePrice = formatNumber(change.price, { Decimals: 2, Default: '0.00',Plus: true });
	let prevClose = formatNumber(goodPrevClose, { Decimals: 2, Default: '0.00' });
	let open = formatNumber(quote.Open, { Decimals: 2, Default: '0.00' });
	let lastTrade = formatLastTradeTime(quote.LastTradeTime);

	let analysis;
	if (change.price > 0) {
		if (change.price > 5) {
			analysis = <p><span class={style.highlight}>{name}</span> <Text id={`${INTL_NS}.gappedUp`}>gapped up</Text> <span class={style.positive}>{changePrice}</span> <Text id={`${INTL_NS}.overnightOpeningAt`}>overnight, opening at</Text> <span class={style.highlight}>{open}</span> <Text id={`${INTL_NS}.offOfAPreviousCloseOf`}>off of a previous close of</Text> <span class={style.highlight}>{prevClose}</span></p>;
		}
		else if (change.price > 0.5) {
			analysis = <p><span class={style.highlight}>{name}</span> <Text id={`${INTL_NS}.openedAt`}>opened at</Text> <span class={style.highlight}>{open}</span> <Text id={`${INTL_NS}.todayAnIncreaseOf`}>today, an increase of</Text> <span class={style.positive}>{changePrice}</span> <Text id={`${INTL_NS}.fromThePreviousCloseOf`}>from the previous close of</Text> <span class={style.highlight}>{prevClose}</span></p>;
		}
		else {
			analysis = <p><span class={style.highlight}>{name}</span> <Text id={`${INTL_NS}.openedSlightlyUpTodayIncreasing`}>opened slightly up today, increasing</Text> <span class={style.positive}>{changePrice}</span> <Text id={`${INTL_NS}.fromThePreviousCloseOf`}>from the previous close of</Text> <span class={style.highlight}>{prevClose}</span></p>;
		}
	}
	else if (change.price < 0) {
		if (change.price < -5) {
			analysis = <p><span class={style.highlight}>{name}</span> <Text id={`${INTL_NS}.sharesDroppedOvernightTo`}>shares dropped overnight to</Text> <span class={style.highlight}>{open}</span><Text id={`${INTL_NS}.aDeclineOf`}>, a decline of</Text> <span class={style.negative}>{changePrice}</span> <Text id={`${INTL_NS}.fromThePreviousCloseOf`}>from the previous close of</Text> <span class={style.highlight}>{prevClose}</span></p>;
		}
		else if (change.price < -0.5) {
			analysis = <p><span class={style.highlight}>{name}</span> <Text id={`${INTL_NS}.movedDownwardBy`}>moved downward by</Text> <span class={style.negative}>{changePrice}</span> <Text id={`${INTL_NS}.pointsOpeningAt`}>points, opening at</Text> <span class={style.highlight}>{open}</span> <Text id={`${INTL_NS}.todayComparedToAPreviousCloseOf`}>today, compared to a previous close of</Text> <span class={style.highlight}>{prevClose}</span></p>;
		}
		else {
			analysis = <p><span class={style.highlight}>{name}</span> <Text id={`${INTL_NS}.openedSlightlyDownTodayDecreasing`}>opened slightly down today, decreasing</Text> <span class={style.highlight}>{changePrice}</span> <Text id={`${INTL_NS}.to`}>to</Text> <span class={style.highlight}>{open}</span></p>;
		}
	}
	else if (quote.volume > 0) {
		analysis = <p><span class={style.highlight}>{name}</span> <Text id={`${INTL_NS}.sharesOpenedFlatTodayAt`}>shares opened flat today at</Text> <span class={style.highlight}>{open}</span></p>;
	}
	else {
		analysis = <p><span class={style.highlight}>{name}</span> <Text id={`${INTL_NS}.sharesHaveNotTradedSince`}>shares have not traded since</Text> <span class={style.highlight}>{lastTrade}</span></p>;
	}

	return (
		<div class="stock-open-analysis">
			{ analysis }
		</div>
	);
};
export default StockOpenAnalysis;



// WEBPACK FOOTER //
// ../node_modules/@cube/finance-components/src/components/stock-open-analysis/index.js